// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 20px 0 20px 0;
}

.error-img-container {
  display: block;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

.maintenanceText {
  text-align: left;
}

.wc-container .wc-container-in #maintenanceTitle {
  text-align: left;
}
.wc-container .wc-container-in .principal-title {
  text-align: left;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
